<dx-data-grid #masterDetailsGridContainer class="data-grid" [dataSource]="lineItems" [remoteOperations]="false" [allowColumnReordering]="true" [rowAlternationEnabled]="true" [showBorders]="true">
	<dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-state-storing [enabled]="true" type="localStorage" storageKey="ediSummaryGridFixingsDetails"></dxo-state-storing>
	<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
	<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
	<dxo-group-panel [visible]="false"></dxo-group-panel>
	<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="false"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column dataField="purchasableItem" dataType="text" alignment="left" caption="Item"></dxi-column>
	<dxi-column dataField="quantityRequired" dataType="number" alignment="left" caption="Quantity Required"></dxi-column>
</dx-data-grid>